import React from 'react';
import PropTypes from 'prop-types';
import ErrorDisplay from '../shared/errorDisplay';

const PreviewPage = props => {
  const errorOutput = {
    'too-long-comment':
      'Your comment exceeds the maximum character count of 350. Please edit your comment before resubmitting.',
    'network-comment':
      'The browser detected a network error while submitting your comment. Please try again.',
    'conflict-comment':
      'Unable to submit your comment. A leader comment has already been received for this recipient.',
  };

  const disabled = !!(
    props.error &&
    (props.error === 'conflict-comment' || props.error === 'too-long-comment')
  );

  return (
    /* eslint-disable jsx-a11y/anchor-is-valid */
    /* eslint-disable jsx-a11y/click-events-have-key-events */
    /* eslint-disable jsx-a11y/no-static-element-interactions */
    /* eslint-disable react/no-danger */
    <div className="preview">
      <h4 className="deadline">
        <span dangerouslySetInnerHTML={{ __html: props.commentByDate }} />
      </h4>
      <h1>{props.translations['review-comment']}</h1>
      <div>
        <a
          className="back"
          title="edit"
          onClick={() => props.togglePreview(false)}
          style={{ color: props.color }}
        >
          <span>&laquo; {props.translations.edit}</span>
        </a>
      </div>

      <div className={props.isLeader ? 'photos clearfix' : 'polaroid'}>
        {props.uploadedImages[0] && (
          <div
            className={props.isLeader ? 'frame' : 'stencil'}
            style={{ backgroundImage: `url(${props.uploadedImages[0].url})` }}
          />
        )}
        {props.isLeader &&
          props.uploadedImages[1] && (
            <div
              className="frame"
              style={{ backgroundImage: `url(${props.uploadedImages[1].url})` }}
            />
          )}
        {props.isLeader &&
          props.uploadedImages[2] && (
            <div
              className="frame"
              style={{ backgroundImage: `url(${props.uploadedImages[2].url})` }}
            />
          )}
        {!props.isLeader && (
          <p className="caption">{props.tempComment.comment}</p>
        )}
        {!props.isLeader && <p className="name">{props.tempComment.name}</p>}
      </div>

      {props.isLeader && (
        <p className="comments">{props.tempComment.comment}</p>
      )}
      {props.isLeader && <p className="signature">{props.tempComment.name}</p>}

      <p>
        <strong>{props.translations['please-note']}</strong>
        <span> {props.translations['once-submit']}</span>
      </p>

      {props.error &&
        Object.prototype.hasOwnProperty.call(errorOutput, props.error) && (
          <ErrorDisplay errorMessage={errorOutput[props.error]} />
        )}

      <button
        id="submit-comment"
        className={props.spinnerDisplay ? 'form-loading' : null}
        type="button"
        style={{ backgroundColor: props.color }}
        onClick={props.submitComment}
        disabled={disabled}
      >
        {props.translations['submit-comment']}
      </button>
    </div>
    /* eslint-enable jsx-a11y/anchor-is-valid */
    /* eslint-enable jsx-a11y/click-events-have-key-events */
    /* eslint-enable jsx-a11y/no-static-element-interactions */
    /* eslint-enable react/no-danger */
  );
};

PreviewPage.propTypes = {
  commentByDate: PropTypes.string.isRequired,
  spinnerDisplay: PropTypes.bool.isRequired,
  submitComment: PropTypes.func.isRequired,
  tempComment: PropTypes.shape({
    comment: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  togglePreview: PropTypes.func.isRequired,
  translations: PropTypes.objectOf(PropTypes.string).isRequired,
  color: PropTypes.string.isRequired,
  isLeader: PropTypes.bool.isRequired,
  error: PropTypes.string,
  uploadedImages: PropTypes.array,
};

PreviewPage.defaultProps = {
  error: '',
  uploadedImages: [],
};

export default PreviewPage;
